export const removeDot = (value: string) => {
    return value.replaceAll(".", "").replaceAll(",", "");
};
